var wheelRPM = 0; 
var circumf = 0;
var mph = 0;
var wheelconversion = 0;
var speedconversion = 0;

function entsub() {
  if (event && event.which == 13)
    calculatespeed();
  }
	
function calculatespeed() {
	diameter = parseFloat(document.speedConvert.inputDiamter.value);
	rpm = parseFloat(document.speedConvert.inputErpm.value);
	sprocket = parseFloat(document.speedConvert.inputAxleTeeth.value);
	clutch = parseFloat(document.speedConvert.inputClutchTeeth.value);
	mph = parseFloat(document.speedConvert.inputSpeed.value);
	
	wheelconversion = 12;
	speedconversion = 88;
    
	wheelRPM = rpm / ( sprocket / clutch );
	circumf = ( 3.14 * diameter ) / wheelconversion;
	mph = ( wheelRPM * circumf ) / speedconversion;
	mph = Math.round (mph);

	document.speedConvert.inputSpeed.value = mph;	
}

function calculatespeed2() {
	diameter = parseFloat(document.speedConvert.inputDiamter.value);
	rpm = parseFloat(document.speedConvert.inputErpm.value);
	sprocket = parseFloat(document.speedConvert.inputAxleTeeth.value);
	clutch = parseFloat(document.speedConvert.inputClutchTeeth.value);
	mph = parseFloat(document.speedConvert.inputSpeed.value);
	
  	wheelconversion = 100;
	speedconversion = 16;
  
	wheelRPM = rpm / ( sprocket / clutch );
	circumf = ( 3.14 * diameter ) / wheelconversion;
	mph = ( wheelRPM * circumf ) / speedconversion;
	mph = Math.round (mph);

	document.speedConvert.inputSpeed.value = mph;	
}